<template>
  <b-form-group
    :label="label"
    :style="!label ? 'margin-bottom:0' : ''"
  >
    <validation-provider
      #default="{ errors }"
      :rules="{required: require_}"
      :name="label"
    >
      <b-input
        ref="inputRef"
        :value="formattedValue"
        :state="errors.length > 0 || erro ? false : null"
        type="text"
        :disabled="disabled"
        @input="emitirPai"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { watch } from '@vue/composition-api'
import { useCurrencyInput } from 'vue-currency-input'
import {
  required,
} from '@validations'
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'DinheiroInput',
  components: {
    ValidationProvider,
  },
  props: {
    value: { type: Number, default: 0 },
    options:
    {
      type: Object,
      default: () => ({
        currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false, locale: 'pt-BR',
      }),
    },
    label: { type: String, default: '' },
    require: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      required,
      erro: false,
    }
  },
  setup(props) {
    const { formattedValue, inputRef, setValue } = useCurrencyInput(props.options)
    watch(() => props.value, value => {
      setValue(value)
    })

    return { inputRef, formattedValue }
  },
  computed: {
    require_: {
      get() {
        return this.require
      },
    },
  },
  methods: {
    emitirPai() {
      this.$emit('input', this.value)
    },
  },
}
</script>
